import { callApi } from 'utils/api';

/**
 * @return {Promise<display>}
 */
export const fetchDisplaySettingsApi = () => callApi('settings/display');

/**
 * @return {Promise<channel[]>}
 */
export const updateGroupsApi = (startChannels) =>
  callApi('settings/display/groups', 'PUT', startChannels).then((settings) => settings.startChannels);

export const fetchSecuritySettingsApi = () => callApi('settings/security');
